'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function onPlay(event) {
  if (event.playReason === 'autostart') {
    this.setState({
      hasPlayed: true
    });
    this.props.onAutoStart(event);
  } else if (this.state.hasPlayed && (event.oldstate === 'buffering' || event.oldstate === 'paused')) {
    this.props.onResume(event);
  } else {
    this.props.onPlay(event);
    this.setState({
      hasPlayed: true
    });
  }
}

exports.default = onPlay;


//////////////////
// WEBPACK FOOTER
// ./~/react-jw-player/dist/create-event-handlers/on-play.js
// module id = 1785
// module chunks = 1